// TabsulLandingPage.js
import React from "react";
import classes from "./TabsulLandingPage.module.css";
import logo from "../Assets/green.png";
import study from "../Assets/study.png"
import FirstAd from "./FirstAd";

export default function TabsulLandingPage() {
  return (
    <div className={classes.page}>
      
      {/* HERO (Centered Logo + Description) */}
      <section className={classes.hero}>
        <img src={logo} alt="Tabsul Logo" className={classes.heroLogo} />

        <p className={classes.heroText}>
          Tabsul is a pharmacy exam preparation platform designed for HAAD, DOH,
          and MOH licensing exams. Practice with structured mock tests, improve
          performance, and build confidence to pass your exams.
        </p>

        {/* <button className={classes.contributeBtn}>
          Contribute
        </button> */}
      </section>

      <img src={study} alt="study" className={classes.study} />


      {/* HAAD */}
      <section className={classes.section}>
        <h1>DOH PHARMACY</h1>
        <p>
          The DOH Pharmacy Exam (formerly HAAD) is the mandatory licensure exam for pharmacists who want to work legally in Abu Dhabi. It is administered through Pearson VUE after your credentials are approved, and it tests pharmaceutical knowledge, clinical judgment, and UAE‑specific regulations. </p>
        <div className={classes.btnRow}>
          <a href="/mocktest/doh" className={classes.btn}>
            Mock Test
          </a>
          <a href="/learn/doh" className={classes.btnOutline}>
            Learn
          </a>
        </div>
      </section>

      <FirstAd />

      {/* DOH */}
      <section className={classes.section}>
        <h1>DHA PHARMACY</h1>
        <p>
          The DHA Pharmacy Exam is a licensing test required for pharmacists who want to work in Dubai. It assesses essential knowledge in pharmacology, clinical practice, drug safety, and UAE healthcare regulations through multiple‑choice questions. Passing the exam is necessary to obtain a DHA license, ensuring that pharmacists meet professional standards and can safely practice in hospitals and community pharmacies across Dubai.
        </p>
        <div className={classes.btnRow}>
          <a href="/mocktest/dha" className={classes.btn}>
            Mock Test
          </a>
          <a href="/learn/dha" className={classes.btnOutline}>
            Learn
          </a>
        </div>
      </section>

      {/* MOH */}
      <section className={classes.section}>
        <h1>MOH PHARMACY</h1>
        <p>
          The MOH Pharmacy Exam is a licensing test required for pharmacists who want to work in UAE emirates outside Dubai and Abu Dhabi. It evaluates core knowledge in pharmacology, clinical pharmacy, drug safety, pharmaceutical calculations, and UAE healthcare laws through multiple‑choice questions. Passing the exam allows candidates to obtain a Ministry of Health (MOH) license, enabling them to practice in government and private healthcare facilities across the northern emirates. The exam focuses on practical, patient‑centered scenarios, making solid preparation essential for success.
        </p>
        <div className={classes.btnRow}>
          <a href="/mocktest/moh" className={classes.btn}>
            Mock Test
          </a>
          <a href="/learn/moh" className={classes.btnOutline}>
            Learn
          </a>
        </div>
      </section>

      {/* FOOTER */}
      <footer className={classes.footer}>
        <div className={classes.footerGrid}>
          
          <div>
            <h3>About Us</h3>
            <p className={classes.about}>
              Tabsul helps pharmacy professionals prepare for licensing exams
              through structured practice and performance tracking.
            </p>
          </div>

          <div>
            <h3>Contact Us</h3>
            <p className={classes.about}>info@tabsul.me</p>
          </div>

          <div>
            <h3>Legal</h3>
            <a className={classes.about} href="/privacy">Privacy Policy</a>
            <a className={classes.about} href="/terms">Terms & Conditions</a>
          </div>

        </div>

        <p className={classes.copy}>
          © {new Date().getFullYear()} Tabsul
        </p>
      </footer>

    </div>
  );
}